import { useState, type ReactNode } from 'react';
import { Toaster, type Toast } from '@forecastify/ui';
import { useT } from '../i18n';

/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 26 Oct 2026 · A SAVE THAT LANDED SAYS SO.                                 │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The product owner: the create/edit dialogs close only when the save lands, and then confirm it
 * with a toast. Most settings screens had no toast area at all; this is the one they share —
 * `saved(title)` queues a success toast, `toaster` is the element the screen renders once.
 */
export function useSaveToasts(): {
  readonly saved: (title: string) => void;
  readonly toaster: ReactNode;
} {
  const t = useT();
  const [toasts, setToasts] = useState<readonly Toast[]>([]);
  return {
    saved: (title) => {
      setToasts((current) => [
        ...current,
        { id: `saved-${String(Date.now())}-${String(current.length)}`, title, variant: 'success' },
      ]);
    },
    toaster: (
      <Toaster
        toasts={[...toasts]}
        label={t('settings.toasts')}
        dismissLabel={t('common.close')}
        onDismiss={(id) => {
          setToasts((current) => current.filter((entry) => entry.id !== id));
        }}
      />
    ),
  };
}
